goog.provide('el8.tourguide.homeSuggestChart');

goog.require('el8.tourguide.InfoBox');
goog.require('el8.template.tourguide.homeSuggestChart');

el8.tourguide.homeSuggestChart = (function() {

    var that = new el8.tourguide.InfoBox();

    var super_show = that.show;
    that.show = function() {
        var $elt = $('.el8FeedItem:first', '#req-act-messages-feed-list');
        super_show.call(that, {
            contentFn: el8.template.tourguide.homeSuggestChart.content,
            parentContainer: $('.req-act-section[data-name="messages"]', '#req-act-contents'),
            styleClass: 'suggestInfoBox',
            height: 160,
            width: 350,
            left: 300,
            top: 95
        });
        that.getContainer().on('click', '.close-trigger',  function() {
            that.hide();
        });
        $('.chartSignOffTrigger', $elt).prop('disabled', true);
    };

    return that;

})();
